import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {Alert, Badge, Button, Card, Col, Form, Row, Spinner, Tab, Table, Tabs,} from "react-bootstrap";
import {GoDownload} from "react-icons/go";
import {
    addDocumentTraining,
    addTrainingComment,
    downloadTrainingDocument,
    retrieveTrainingComments,
    retrieveTrainingDetail,
    setAttendance,
} from "../../Api/Teams/Trainings/TrainingsFetch";
import {formatDataIt} from "../../Utils/DateFormat";
import {emptyError} from "../../Components/Errors";
import CommentsComponent from "../../Components/Layout/Elements/CommentsComponent";
import AuthContext from "../../Contexts/authContext";

const AttendancePill = ({present, onClick}) => {
    const states = {
        true:  {bg: '#d1fae5', border: '#6ee7b7', dot: '#10b981', text: '#065f46', label: 'Presente'},
        false: {bg: '#fee2e2', border: '#fca5a5', dot: '#ef4444', text: '#991b1b', label: 'Assente'},
        null:  {bg: '#f3f4f6', border: '#d1d5db', dot: '#9ca3af', text: '#6b7280', label: 'Non segnato'},
    };
    const key = present === true ? 'true' : present === false ? 'false' : 'null';
    const s = states[key];
    return (
        <div
            onClick={onClick}
            style={{
                display: 'inline-flex', alignItems: 'center', gap: '7px', cursor: 'pointer',
                background: s.bg, border: `1.5px solid ${s.border}`, borderRadius: '999px',
                padding: '4px 12px 4px 8px', transition: 'all 0.2s', userSelect: 'none',
            }}
        >
            <span style={{width: '10px', height: '10px', borderRadius: '50%', background: s.dot, display: 'inline-block', flexShrink: 0}}/>
            <span style={{fontSize: '13px', fontWeight: 500, color: s.text, whiteSpace: 'nowrap'}}>{s.label}</span>
        </div>
    );
};

const TrainingDetailPage = () => {
    const {id} = useParams();
    const {user} = useContext(AuthContext);
    const userRoles = user?.profiles?.[0]?.associations?.[0]?.roles ?? [];
    const isCoach = user?.is_admin === 1 || userRoles.includes('Coach');
    const [message, setMessage] = useState();
    const [errors, setErrors] = useState();
    const [isLoading, setIsLoading] = useState();
    const [comments, setComments] = useState();
    const [update, setUpdate] = useState();
    const [newComment, setNewComment] = useState();
    const [trainingDetail, setTrainingDetail] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const [addDocument, setAddDocument] = useState(false);
    const [activeTab, setActiveTab] = useState("invitations");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        retrieveTrainingDetail({idDetail: id, setTrainingDetail, setIsLoading, setErrors, setMessage});
        retrieveTrainingComments({id, setComments, setIsLoading, setErrors, setMessage});
    }, [update]);

    const handleSumbit = async () => {
        const formattedData = {comment: newComment};
        await addTrainingComment({id, newComment: formattedData, setMessage, setErrors, setIsLoading, setUpdate, update});
        setUpdate({});
    };

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSend = (e) => {
        e.preventDefault();
        emptyError();
        if (!document.querySelector("span.error_empty_field")) {
            setAddDocument((prev) => !prev);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (selectedFile && addDocument) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("document_type_id", 2);
            addDocumentTraining({id, addDocument, formData, setMessage, setIsLoading, update, setUpdate, setErrors});
        }
    }, [addDocument]);

    const date_time_str = trainingDetail?.start_time;
    const date_time_str_end = trainingDetail?.end_time;

    const formatted_date_time = new Date(date_time_str).toLocaleString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });

    const formatted_date_time_end = new Date(date_time_str_end).toLocaleString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });

    return (
        <>
            <Row>
                <Col>
                    <Card className="shadow border-0 py-3 px-3 text-start">
                        <Row>
                            {message && (
                                <Alert variant="success" onClick={() => setMessage(null)} dismissible>
                                    {message}
                                </Alert>
                            )}
                            {errors && typeof errors === "string" && (
                                <Alert variant="danger" onClick={() => setErrors(null)} dismissible>
                                    {errors}
                                </Alert>
                            )}

                            <Col md={6}>
                                <h2 className="mb-3 text-start">{trainingDetail && trainingDetail.team}</h2>
                            </Col>

                            <Col md={6}>
                                <p>
                                    <b>Inizio allenamento:</b> {formatted_date_time}
                                </p>
                                <p>
                                    <b>Fine allenamento:</b> {formatted_date_time_end}
                                </p>
                                <p>
                                    <b>Luogo:</b> {trainingDetail && trainingDetail.location}
                                </p>
                                <p>
                                    <b>Descrizione:</b> {trainingDetail && trainingDetail.description}
                                </p>
                            </Col>

                        </Row>
                    </Card>
                </Col>

                <Col className="col-12 mt-3">
                    <Card className="shadow border-0 py-3 px-3 text-start">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => setActiveTab(key || "comments")}
                            className="mb-3"
                        >
                            <Tab eventKey="invitations" title="Convocati">
                                {trainingDetail && trainingDetail.invitations.length > 0 ? (
                                    <Table hover responsive>
                                        <thead>
                                        <tr>
                                            <th className="bkg-primary text-white">Nome</th>
                                            <th className="bkg-primary text-white">Ruolo</th>
                                            <th className="bkg-primary text-white">Partecipa</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {trainingDetail.invitations.map((conv) => (
                                            <tr key={conv.id}>
                                                <td>{conv.profile_name}</td>
                                                <td>{conv.sport_role_name}</td>
                                                <td>
                                                    <Badge
                                                        bg={
                                                            conv.accepted === null
                                                                ? "secondary"
                                                                : conv.accepted === 0
                                                                    ? "danger"
                                                                    : "success"
                                                        }
                                                        style={{color: '#fff'}}
                                                    >
                                                        {conv.accepted === null
                                                            ? "Non ha risposto"
                                                            : conv.accepted === 0
                                                                ? "No"
                                                                : "Sì"}
                                                    </Badge>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <p className="text-muted">Nessun convocato.</p>
                                )}
                            </Tab>

                            <Tab eventKey="attendance" title="Presenze">
                                {trainingDetail && trainingDetail.invitations.length > 0 ? (
                                    <Table hover responsive>
                                        <thead>
                                        <tr>
                                            <th className="bkg-primary text-white">Nome</th>
                                            <th className="bkg-primary text-white">Ruolo</th>
                                            <th className="bkg-primary text-white">Presenza</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {trainingDetail.invitations.map((conv) => {
                                            const presentBool = conv.present === 1 ? true : conv.present === 0 ? false : null;
                                            return (
                                                <tr key={conv.id}>
                                                    <td className={'align-middle'}>{conv.profile_name}</td>
                                                    <td className={'align-middle'}>{conv.sport_role_name}</td>
                                                    <td className={'align-middle'}>
                                                        {isCoach ? (
                                                            <AttendancePill
                                                                present={presentBool}
                                                                onClick={() => setAttendance({
                                                                    scheduleId: id,
                                                                    profileId: conv.profile_id,
                                                                    present: conv.present !== 1,
                                                                    setUpdate,
                                                                    setErrors,
                                                                })}
                                                            />
                                                        ) : (
                                                            <AttendancePill present={presentBool}/>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <p className="text-muted">Nessun convocato.</p>
                                )}
                            </Tab>

                            <Tab eventKey="comments" title="Commenti">
                                <CommentsComponent comments={comments} setNewComment={setNewComment} handleSumbit={handleSumbit}/>
                            </Tab>

                            <Tab eventKey="documents" title="Documenti">
                                <Row>
                                    <Row className={'justify-content-between align-items-end mb-5'}> <Col md={8}>
                                        <Form.Group controlId="formFile" >
                                            <Form.Label>Seleziona un file</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="file"
                                                onChange={handleFileChange}
                                            />
                                        </Form.Group>
                                    </Col> <Col md={4}>
                                        <Button onClick={handleSend} className="mt-3">
                                            Carica documento
                                        </Button>
                                    </Col>
                                    </Row>
                                    {trainingDetail && trainingDetail?.documents.length > 0 ? (
                                        <Table hover responsive>
                                            <thead>
                                            <tr>
                                                <th className="bkg-primary text-white">Nome file</th>
                                                <th className="bkg-primary text-white">Tipo</th>
                                                <th className="bkg-primary text-white">Dimensione</th>
                                                <th className="bkg-primary text-white">Caricato il</th>
                                                <th className="bkg-primary text-white"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {trainingDetail.documents.map((doc) => (
                                                <tr key={doc.id}>
                                                    <td>{doc.original_filename}</td>
                                                    <td>{doc.mime_type}</td>
                                                    <td>{doc.size < 1024 ? doc.size + ' B' : doc.size < 1048576 ? (doc.size / 1024).toFixed(1) + ' KB' : (doc.size / 1048576).toFixed(1) + ' MB'}</td>
                                                    <td>{formatDataIt(new Date(doc.created_at))}</td>
                                                    <td>
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => downloadTrainingDocument({id, documentId: doc.id, setIsLoading, setErrors})}
                                                        >
                                                            <GoDownload className="me-1"/>
                                                            Scarica
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <p className="text-muted">Nessun documento ancora.</p>
                                    )}
                                </Row>
                            </Tab>
                        </Tabs>
                    </Card>
                </Col>

                {isLoading && <Spinner className="mt-3"/>}
            </Row>
        </>
    );
};

export default TrainingDetailPage;
